import { render, staticRenderFns } from "./EnvironmentTag.vue?vue&type=template&id=2e3b47de&scoped=true&"
import script from "./EnvironmentTag.vue?vue&type=script&lang=js&"
export * from "./EnvironmentTag.vue?vue&type=script&lang=js&"
import style0 from "./EnvironmentTag.vue?vue&type=style&index=0&id=2e3b47de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3b47de",
  null
  
)

export default component.exports